
import React, { Component } from 'react'
import { Stepper } from '@operations/shared';
import { updateBulkProductsApi } from '../../utils/apisConsts';
import { bulkUpdateProductsTemplate } from '../../utils/bulkSheetsTemplates';
import Confirmation from '../bulkCreateProducts/confirmation';
import UploadProds from '../bulkCreateProducts/uploadProducts';

class BulkUpdateProducts extends Component {
    state = {
        componentSteps: [
            {
                title: 'Upload Products',
                content: <UploadProds isUpdate={true} validCols={bulkUpdateProductsTemplate} fileUrl={`https://elasticbeanstalk-us-east-1-927288046810.s3.amazonaws.com/Nowpay-Docs/update-products-template.xlsx`}/>,
                id: 0,
            }, {
                title: 'Confirmation',
                content: <Confirmation apiLink={updateBulkProductsApi} dataKey='products' isUpdate={true}/>,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <div className='bulkCreateProducts'>
                    <Stepper componentSteps={componentSteps} />
                </div>
            </>
        )
    }
}

export default BulkUpdateProducts
